import Platform from '../platform';
import BScroll from 'better-scroll';

export default {
	initIScroll: (elementSelector, options = {}) => {
		var myScrollOptions = {
			...options,
			tap: true,
			click: iScrollClick(),
		};

		if (Platform.isNativeApp) {
			myScrollOptions.disableMouse = true;
			myScrollOptions.disablePointer = true;
		} else {
			myScrollOptions.mouseWheel = true;
		}

		function iScrollClick() {
			if (/iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)) return false;
			if (/Chrome/i.test(navigator.userAgent)) return /Android/i.test(navigator.userAgent);
			if (/Silk/i.test(navigator.userAgent)) return false;
			if (/Android/i.test(navigator.userAgent)) {
				if (/Mozilla/i.test(navigator.userAgent)) return true;
				var s = navigator.userAgent.substr(navigator.userAgent.indexOf('Android') + 8, 3);
				return parseFloat(s[0] + s[3]) < 44 ? false : true;
			}
		}

		if (Platform.isAndroid) {
			myScrollOptions.bounce = false;
		}

		return new BScroll(elementSelector, myScrollOptions);
	},
	refreshPageScroll: () => {
		if (snappoApp && snappoApp._pageScroll) {
			setTimeout(function () {
				snappoApp._pageScroll.refresh();
			}, 0);
		}
	},
	disablePageScroll() {
		snappoApp._pageScroll && snappoApp._pageScroll.disable();
	},
	enablePageScroll() {
		snappoApp._pageScroll && snappoApp._pageScroll.enable();
	},
};
